import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { CreateOrderFormSection } from './styles';

interface CreateOrderDraftEditConditionProps {
  times: number;
  draftModificationTerms: string;
  isWithdrawn: boolean;
}

const CreateOrderDraftEditCondition: React.FC<CreateOrderDraftEditConditionProps> = ({
  times,
  draftModificationTerms
}) => {
  return (
    <CreateOrderFormSection>
      <CustomizedTypography
        variant={'h4'}
        gutterBottoms={8}
        fontWeight="500"
        color="textPrimary"
      >
        시안 수정 조건
      </CustomizedTypography>
      <CustomizedTypography variant={'body1'} color="primary" fontWeight="500">
        최대 {times}회까지
      </CustomizedTypography>

      <CustomizedTypography
        variant={'body1'}
        color="textPrimary"
        className="pre-line"
      >
        {draftModificationTerms}
      </CustomizedTypography>
    </CreateOrderFormSection>
  );
};

export default CreateOrderDraftEditCondition;
